import loadable from '@loadable/component';

export const AboutBrand = loadable(() => import('./index'), {
  resolveComponent: (components) => components.AboutBrand,
});
